module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iNyIgY3k9IjciIHI9IjciIGZpbGw9IiMwMEQ4NzAiLz4KPHBhdGggZD0iTTUuMDE3OTYgNy4zNjg0MUw1Ljk1MjQzIDguMjQwNThDNi4xNjAzNyA4LjQzNDY1IDYuNDg4MSA4LjQxNjQxIDYuNjczMjEgOC4yMDA0NEw4Ljk2NTMzIDUuNTI2MzEiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./static/header/check.svg
// module id = 88
// module chunks = 245 247